import { debugLog } from "./debugUtils";

/**
 * Runs a series of field validators and sets errors via provided setter functions.
 * @param {Object} data           - The object to validate (e.g., currentItem, currentBaseline)
 * @param {Array} validators      - Array of { field, validate, setError, message } objects
 * @returns {boolean}             - true if all fields valid, false if any error found
 */
export const verifyFields = (data, validators) => {
	let errorFound = false;
	validators.forEach(({ field, validate, setError, message }) => {
		const value = (data[field] ?? "").toString().trim(); // normalize for all field types

		debugLog(4, "[formValidationUtils][PROCESS] verifyFields input", {
			data: data,
			validate: validate,
			value: value,
		});

		if (validate(value)) {
			setError("");
		} else {
			debugLog(3, `[formValidationUtils][STATE] validation failed: ${field}`, {
				value: value,
				message: message,
			});
			setError(message);
			errorFound = true;
		}
	});
	return errorFound;
};
